module.exports = __webpack_public_path__ + "static/img/knob_potenciometro-1.0eeec0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/knob_potenciometro-1.svg
// module id = bJLE
// module chunks = 0